import React from 'react';

import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';
import YearPicker from 'Components/YearPicker';

export default ({outCount, handleRowCountSelect, rowsCount, handleSelectFilter, filterState, engineTypes}) => {
  const BRAND_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Approved', value: 'APPROVED' },
    { name: 'Pending', value: 'PENDING' },
    { name: 'Incomplete', value: 'INCOMPLETE' },
    { name: 'Deactivated', value: 'DEACTIVATED' },
  ];

  const FEE_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Unpaid', value: false },
    { name: 'Paid', value: true },
  ];

  const AGREEMENT_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Signed', value: true },
    { name: 'Not signed', value: false },
  ];

  const currentYear = new Date().getFullYear();

  const engineTypesWithAllField = ['All'].concat(engineTypes);

  const getSelectedItem = (key, possibleItemsList) => {
    if (filterState[key] === undefined) return possibleItemsList[0];
    return possibleItemsList.find(item => (item.value === undefined ? item : item.value) === filterState[key]);
  };

  return (
    <section className='list-scene__utility-section-wrapper'>
      <section className='list-scene__utility-section-filters-wrapper'>
        <div className='list-scene__utility-section-filters-header'>Filter</div>
        <Select
          selectionList={FEE_STATUSES}
          handleSelect={handleSelectFilter('isPaid')}
          placeholder='All'
          defaultItem={getSelectedItem('isPaid', FEE_STATUSES)}
          label={'by Fee Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={AGREEMENT_STATUSES}
          handleSelect={handleSelectFilter('brandSignStatus')}
          placeholder='All'
          defaultItem={getSelectedItem('brandSignStatus', AGREEMENT_STATUSES)}
          label={'by Agreement Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={BRAND_STATUSES}
          handleSelect={handleSelectFilter('applicationStatus')}
          placeholder='All'
          defaultItem={getSelectedItem('applicationStatus', BRAND_STATUSES)}
          label={'by Application Status'}
          itemNameIndicator='name'
          type={selectType.listFilter}
        />
        <Select
          selectionList={engineTypesWithAllField}
          handleSelect={handleSelectFilter('formulaEngineType')}
          label={'by Engine Oil Type'}
          placeholder='All'
          defaultItem={filterState.formulaEngineType || engineTypesWithAllField[0]}
          type={selectType.listFilter}
        />
        <YearPicker
          endYear={currentYear + 1}
          yearPickAction={handleSelectFilter('year')}
          label='by Year'
          year={filterState.year}
          withAllOption
          width={160}
          height={18}
        />
      </section>

      <section className='list-scene__utility-section-rows-select-wrapper'>
        <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowCountSelect} selectedRowsCount={rowsCount} />
      </section>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/List/FiltersSection.jsx